import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { parentFind } from "library/tree/index.mjs"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { getDemandForFeature } from "lib/features"
import { FEATURE_FLAG_REGIME_PERMISSIONS } from "../regime-access/regime-access.runtime"
import { EDIT_TREE } from "library/constants.mjs"
import { ScheduleSelectorWrapper } from "slot-definitions"
import { PlanRoot } from "library/tree/constants.mjs"

ScheduleSelectorWrapper.plug(<RegimeGuard />)

function RegimeGuard({ children }) {
    const { parentItem } = useBoundContext()
    if (parentItem?.id === EDIT_TREE || parentFind(parentItem, (p) => p[PlanRoot])) {
        return (
            <DemandGuard
                demands={[getDemandForFeature(FEATURE_FLAG_REGIME_PERMISSIONS), "manageRegime", "publishRegime"]}
            >
                {children}
            </DemandGuard>
        )
    }
    return children
}
